import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { DEFAULT_SITE_CONTENT, mergeContent } from '@/constants/defaultSiteContent';

const Services = ({ content }) => {
  const c = mergeContent(DEFAULT_SITE_CONTENT.services, content || {});
  const cards = c.cards && c.cards.length ? c.cards : DEFAULT_SITE_CONTENT.services.cards;

  return (
    <section id="services" className="relative py-14 sm:py-24 overflow-hidden isolate">
      <div className="absolute inset-0 -z-10">
        <img src={c.bg_image_url} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-25" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#F5F0E6]/98 via-[#F5F0E6]/92 to-[#EFE8DB]/98" />
      </div>

      <div className="relative max-w-[1360px] mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 sm:gap-4">
          <div>
            <div className="text-[10px] sm:text-[11px] tracking-[0.28em] text-[#0F2E23] font-semibold">
              {c.eyebrow}&nbsp;&nbsp;<span className="inline-block w-12 sm:w-16 h-px bg-[#141414]/40 align-middle" />
            </div>
            <h2 className="mt-3 font-display text-[30px] sm:text-[52px] leading-[1] tracking-tight text-[#141414]">
              {c.heading_top} <span style={{ fontFamily: 'Great Vibes, cursive' }} className="italic text-[#0F2E23]">{c.heading_script}</span>
            </h2>
          </div>
          <p className="max-w-sm text-[13px] sm:text-sm text-[#141414]/70">{c.subhead}</p>
        </div>

        <div className="mt-6 sm:mt-10 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
          {cards.map((s, idx) => (
            <div key={`${s.title}-${idx}`} data-testid={`service-card-${s.title}`} className="group cursor-pointer">
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden shadow-[0_20px_50px_rgba(15,46,35,0.20)] ring-1 ring-black/5">
                <img src={s.image_url} alt={s.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0F2E23]/90 via-[#0F2E23]/45 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-3 sm:p-5 text-[#F5F0E6]">
                  <div className="flex items-start justify-between gap-2 sm:gap-3">
                    <div className="min-w-0">
                      <h3 className="text-[10px] sm:text-[12px] tracking-[0.22em] font-semibold">{s.title}</h3>
                      <p className="mt-1.5 sm:mt-2 text-[11px] sm:text-[13px] leading-snug text-[#F5F0E6]/85 line-clamp-3">{s.body}</p>
                    </div>
                    <span className="shrink-0 inline-flex w-7 h-7 sm:w-8 sm:h-8 items-center justify-center rounded-full bg-[#F5C86A] text-[#0F2E23] opacity-90 group-hover:opacity-100 group-hover:rotate-45 transition-all">
                      <ArrowUpRight className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
